// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__688mf","search":"Settings_search__2p5LJ","filter":"Settings_filter__2HWD6"};